import React from 'react';
import { mockData } from '../mock';
import { Play, Award, Film } from 'lucide-react';

const DirectorBio = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Profile Image */}
          <div className="relative">
            <div className="sticky top-32">
              <img
                src="https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/6z5kgrfd_cc851a7b-9898-438d-bf9f-9d615865ac8b.png"
                alt="Rrammy - Director & Founder of Expresso Films"
                className="w-full h-auto"
              />
              
              {/* Stats overlay */}
              <div className="mt-8 grid grid-cols-3 gap-4">
                <div className="text-center p-4 bg-gray-50">
                  <div className="text-3xl font-light text-gray-900">100+</div>
                  <div className="text-xs text-gray-600 uppercase tracking-wider mt-1">Commercials</div>
                </div>
                <div className="text-center p-4 bg-gray-50">
                  <div className="text-3xl font-light text-gray-900">4</div>
                  <div className="text-xs text-gray-600 uppercase tracking-wider mt-1">Award Films</div>
                </div>
                <div className="text-center p-4 bg-gray-50">
                  <div className="text-3xl font-light text-gray-900">10+</div>
                  <div className="text-xs text-gray-600 uppercase tracking-wider mt-1">Years</div>
                </div>
              </div>
            </div>
          </div>

          {/* Bio Content - Conversational */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-3">
                Meet Rrammy
              </h2>
              <p className="text-xl text-gray-600 font-light">
                Director & Founder of Expresso Films
              </p>
            </div>
            
            <div className="space-y-6 text-gray-700 text-lg leading-relaxed font-light">
              <p>
                Hey there! I am Rrammy, and I have spent the last decade turning brand stories into cinematic experiences that people actually remember.
              </p>
              
              <p>
                As the founder of Expresso Films, I have had the incredible opportunity to direct over 100 television and digital commercials for some of India's most iconic brands. From working with celebrities like Kareena Kapoor Khan, Tisca Chopra, and Shibani Dandekar to crafting emotionally powerful campaigns for Surf Excel and luxury films for Jaquar - every project is a chance to tell a story that matters.
              </p>

              <p>
                But here is what really drives me: the belief that great advertising is not just about selling products - it is about creating moments that resonate. Whether it is a 30-second spot or a long-form narrative, I am obsessed with finding that perfect blend of artistry and strategy that makes brands unforgettable.
              </p>

              <p>
                Beyond commercials, I have directed award-winning short films like Una, Rinti (winner of the prestigious Dadasaheb Phalke Film Puraskar), and The Unknown Codes - films that have traveled to festivals worldwide and reminded me why I fell in love with filmmaking in the first place.
              </p>

              <p className="text-gray-900 font-normal text-xl">
                Right now? I am gearing up for my first feature film - an exciting new chapter that will push creative boundaries and explore deeper storytelling on the big screen.
              </p>

              <p>
                I also love giving back to the filmmaking community. Teaching workshops at IIT Bombay and sharing insights on the Science of Film Making with aspiring directors is one of the most rewarding parts of what I do.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-6">
              <a
                href="https://www.imdb.com/name/nm12609031/?ref_=fn_t_1"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center space-x-2 bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 transition-all duration-300 group"
              >
                <Play size={18} className="group-hover:scale-110 transition-transform" />
                <span className="font-light">View on IMDB</span>
              </a>
              <a
                href="https://vimeo.com/irammy"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center space-x-2 bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 transition-all duration-300 group"
              >
                <Play size={18} className="group-hover:scale-110 transition-transform" />
                <span className="font-light">View on Vimeo</span>
              </a>
              <a
                href="#contact"
                className="inline-flex items-center justify-center space-x-2 border border-gray-900 hover:bg-gray-900 hover:text-white text-gray-900 px-8 py-4 transition-all duration-300 group"
              >
                <Film size={18} className="group-hover:scale-110 transition-transform" />
                <span className="font-light">Start a Project</span>
              </a>
            </div>

            {/* Credentials */}
            <div className="pt-8 border-t border-gray-200">
              <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
                <div className="flex items-center space-x-2">
                  <Award size={16} className="text-gray-900" />
                  <span>Dadasaheb Phalke Award Winner</span>
                </div>
                <span className="text-gray-300">•</span>
                <div className="flex items-center space-x-2">
                  <Film size={16} className="text-gray-900" />
                  <span>Expresso Films Founder</span>
                </div>
                <span className="text-gray-300">•</span>
                <span>Based in Mumbai</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DirectorBio;